import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const emsOverviewRoutes: Array<RouteObject> = [
  {
    index: true,
    lazy: async () => convertRouteModule(await import("./overview")),
  },
];
